import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {SystemReportType} from "../types/SystemReportType";

export const useGetSystemReports = (companyId: number | undefined) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {data, isLoading} = useQuery({
        queryKey: ['get-system-reports', companyId],
        queryFn: async () => await apiClient.get('system-reports/list') as SystemReportType[]
    });

    return {
        data,
        isLoading
    };
};
